import {
  AppBar,
  Dialog,
  Grid,
  IconButton,
  TextareaAutosize,
  Toolbar,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { acceptOrRejectStudentAttachment } from '@webapps/business';
import {
  Button,
  Modal,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const ModalFullScreen = ({
  children,
  idSelect,
  onCancel,
  open,
  refetch,
  rejected,
  title,
  valided,
}) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { addToast } = useToast();
  const [openReject, setOpenReject] = useState(false);
  const [comments, setComments] = useState('');
  const [errorComments, setErrorComments] = useState(false);

  const {
    error: errorAcceptAttachment,
    isLoading: isLoadingAcceptAttachment,
    isSuccess: isSuccessAcceptAttachment,
    mutateAsync: mutateAcceptAttachment,
  } = useMutation(acceptOrRejectStudentAttachment);

  const {
    error: errorRejectAttachment,
    isLoading: isLoadingRejectAttachment,
    isSuccess: isSuccessRejectAttachment,
    mutateAsync: mutateRejectAttachment,
  } = useMutation(acceptOrRejectStudentAttachment);

  const acceptAttachment = async () => {
    await mutateAcceptAttachment({
      id: idSelect,
      comments: '',
      action: 'valid',
    });
  };

  const rejectAttachment = async () => {
    if (comments === '') {
      setErrorComments(true);
    } else {
      await mutateRejectAttachment({
        id: idSelect,
        comments,
        action: 'reject',
      });
      setErrorComments(false);
    }
  };

  useEffect(() => {
    if (isSuccessAcceptAttachment) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      onCancel();
    }
    if (errorAcceptAttachment) {
      addToast({
        status: 'error',
        message: 'Un problème est survenu',
      });
    }
  }, [isSuccessAcceptAttachment, errorAcceptAttachment]);

  useEffect(() => {
    if (isSuccessRejectAttachment) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      setOpenReject(false);
      onCancel();
    }
    if (errorRejectAttachment) {
      addToast({
        status: 'error',
        message: 'Un problème est survenu',
      });
    }
  }, [isSuccessRejectAttachment, errorRejectAttachment]);

  const openRejectModal = () => {
    setOpenReject(true);
    setErrorComments(false);
  };

  return (
    <Dialog fullScreen onClose={onCancel} open={open}>
      <AppBar className={css({ position: 'relative' })}>
        <Toolbar>
          <IconButton
            aria-label="close"
            color="inherit"
            edge="start"
            onClick={onCancel}
          >
            <CloseIcon />
          </IconButton>
          {title}
          {valided === false && (
            <>
              <Button
                className={css({
                  background: '#47C509',
                  color: 'white',
                  marginLeft: spacing(10),
                })}
                disabled={isLoadingAcceptAttachment}
                disableElevation
                onClick={acceptAttachment}
                variant="contained"
              >
                Accepter
              </Button>
              <Button
                className={css({
                  marginLeft: spacing(2),
                })}
                color="secondary"
                disableElevation
                onClick={openRejectModal}
                variant="contained"
              >
                Rejeter
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>
      {children}
      <Modal
        onCancel={() => setOpenReject(false)}
        open={openReject}
        title="Rejeter le document"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextareaAutosize
              className={css({ width: '100%', resize: 'none' })}
              maxLength={100}
              minRows={3}
              name="comments"
              onChange={(event) => {
                setComments(event.target.value);
              }}
              placeholder="Motif (100 mots maximum)"
              value={comments}
            />
            {errorComments && (
              <span className={css({ color: 'red' })}>
                Merci de remplir le motif du rejet.
                <br />
              </span>
            )}
            <span className={css({ color: 'red' })}>
              Cette action est irréversible.
            </span>
          </Grid>
          <Grid
            className={css({ display: 'flex', justifyContent: 'center' })}
            item
            xs={12}
          >
            <Button
              className={css({ borderRadius: '400px' })}
              color="primary"
              disabled={isLoadingRejectAttachment}
              onClick={rejectAttachment}
              variant="outlined"
            >
              Rejeter
            </Button>
          </Grid>
        </Grid>
      </Modal>
    </Dialog>
  );
};

ModalFullScreen.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.node,
  onCancel: PropTypes.func,
  refetch: PropTypes.func,
  idSelect: PropTypes.string,
  valided: PropTypes.bool,
  rejected: PropTypes.bool,
};

export default ModalFullScreen;
